import { useEffect, useMemo, useState } from 'react'
import { useLang } from './useLang'
import { useVideoScale } from './useVideoScale'

type Props = {
  video: HTMLVideoElement
  showedControls: boolean
}

const BaseFontSize = 36

export const Subtitle = ({ video, showedControls }: Props) => {
  const { videoScale } = useVideoScale()
  const { lang } = useLang()
  const [nativeSubtitle, setNativeSubtitle] = useState('')

  // 最初に全ての字幕をhiddenにすることで、デフォルトの字幕が表示されないようにする
  useEffect(() => {
    const tracks = video.textTracks
    for (let i = 0; i < tracks.length; i++) {
      const track = tracks[i]
      track.mode = 'hidden'
    }
  }, [video])

  useEffect(() => {
    const updateNativeSubtitle = () => {
      if (!lang) {
        setNativeSubtitle('')
        return
      }

      const tracks = video.textTracks

      for (let i = 0; i < tracks.length; i++) {
        const track = tracks[i]
        if (track.language === lang && track.activeCues) {
          const cue = track.activeCues[0] as VTTCue
          setNativeSubtitle((cue?.text ?? '').replace(/\n/g, '<br>'))
        }
      }
    }

    updateNativeSubtitle()
    video.addEventListener('timeupdate', updateNativeSubtitle)
    video.addEventListener('seeked', updateNativeSubtitle)
    return () => {
      video.removeEventListener('timeupdate', updateNativeSubtitle)
      video.removeEventListener('seeked', updateNativeSubtitle)
    }
  }, [video, lang])

  const fontSize = useMemo(() => videoScale * BaseFontSize, [videoScale])

  const bottomControlHeight = useMemo(() => videoScale * 140, [videoScale])

  return (
    <div
      style={{
        position: 'absolute',
        bottom: showedControls ? bottomControlHeight + 'px' : '0px',
        padding: '8px',
        transition: 'all 0.2s cubic-bezier(0.3, 0.3, 0.3, 1)',
      }}
    >
      <span
        style={{
          fontSize: `${fontSize}px`,
          fontWeight: 600,
          textShadow: '0 0 7px rgba(0, 0, 0, 1),  0 0 1px rgba(0, 0, 0, 0.4)',
          color: 'white',
          pointerEvents: 'none',
        }}
        dangerouslySetInnerHTML={{ __html: nativeSubtitle }}
      />
    </div>
  )
}
